import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/**
 * SSRFormRedirect - Redirects to the server-side rendered form
 * 
 * This component redirects the user to the backend SSR endpoint
 * which serves a fully rendered HTML page for better performance and SEO.
 * 
 * Route: /:slug/f/registro
 * Redirects to: BACKEND_URL/:slug/f/registro
 */
const SSRFormRedirect = () => {
  const { slug } = useParams();

  useEffect(() => {
    // Get the backend URL from environment or default
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://backiaface.scanmee.io';
    
    // Redirect to the SSR form page on the backend
    window.location.href = `${backendUrl}/${slug}/f/registro`;
  }, [slug]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-700">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white mx-auto mb-4"></div>
        <p className="text-white text-lg">Cargando formulario...</p>
      </div>
    </div>
  );
};

export default SSRFormRedirect;